export const DEFAULT_PAGE_SIZE = 15;
export const PAGE_SIZE_20 = 20;
export const PAGE_SIZE_25 = 25;
export const FIRST_PAGE_NUMBER: number = 0;
